import React from "react"
import { observer, inject } from 'mobx-react'
import HallPanelCfaQr from "./hall_panel_cfa_qr"
import HallPanelDefault from "./hall_panel_default"
import HallPanelQr from "./hall_panel_qr"
import {DesignType} from "../../constants";

const hallListPanelWrapper = {
    "height":"100%",
    "width":"100%",
};

const HallListPanel = ({ RootStore }) => {
    const designType = RootStore.styleStore.currentStyleName
    let HallPanelComponent
    switch (designType) {
        case DesignType.CFA_QR:
            HallPanelComponent = HallPanelCfaQr
            break
        case DesignType.CHECK_IN_QR_AND_CODE:
        case DesignType.CHECK_IN_QR_AND_CODE_AND_TAP:
            HallPanelComponent = HallPanelQr
            break
        default:
            HallPanelComponent = HallPanelDefault
    }
    return (
        <div style={hallListPanelWrapper} id={"container1"}>
            <HallPanelComponent />
        </div>
    )
}

export default inject('RootStore')(observer(HallListPanel))



// WEBPACK FOOTER //
// ./src/components/shop_panel/hall_panel.jsx